import { FruchtermanLayout } from '@antv/layout/lib/layout/fruchterman';

export default FruchtermanLayout;
